module.exports = __webpack_public_path__ + "static/media/asset-icon.19f2ac62.svg";